import React from 'react'
import { LayoutBand, Separator, Skeleton, colors } from '@fs/zion-ui'

export default function OverviewSkeleton() {
  return (
    <LayoutBand color={colors.background.secondary}>
      <Separator size="lg" />
      <Skeleton.H2 maxWidth="33%" />
      <Skeleton.H2 maxWidth="29%" />
      <Skeleton.Body1 maxWidth="36%" />
      <Separator size="md" />
      <Skeleton.Body1 lines={3} maxWidth="44%" />
      <Skeleton.Body1 lines={3} maxWidth="44%" />
      <Separator size="lg" />
    </LayoutBand>
  )
}
